import { getTaskId, getTaskIdFromAmendsKey } from "authoring/routes/project/amends/lib/task-amends-key"
import { validateTask } from "../task-editor/utilities/task-utils"

export function canOpenAddGroupAmends({ amendsKey, newTasks } = {}) {
    const task = findTaskByAmendsKey(amendsKey, newTasks)
    return validateTask(task)
}

function findTaskByAmendsKey(amendsKey, tasks) {
    const taskId = getTaskIdFromAmendsKey(amendsKey)
    if (!taskId) return null

    const taskList = Array.isArray(tasks) ? tasks : []
    return taskList.find((task) => getTaskId(task) === taskId) ?? null
}
